// BE rejects a REGULAR promo photo whose uploaded file no longer exists (400, nothing persisted).
export const PROMO_PHOTO_FILE_NOT_FOUND_ERROR_CODE = 'DMS-PH-PH-0006';
